var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path, _path2, _circle, _circle2, _circle3, _rect10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgRemainder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 73,
    viewBox: "0 0 76 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 6,
    width: 52.4348,
    height: 67,
    rx: 2,
    fill: "#FFEADB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 21,
    width: 28,
    height: 2,
    rx: 1,
    fill: "#EF7C00"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 20,
    width: 4,
    height: 4,
    rx: 1,
    fill: "#4B4A50"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 30,
    width: 4,
    height: 4,
    rx: 1,
    fill: "#4B4A50"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 40,
    width: 4,
    height: 4,
    rx: 1,
    fill: "#4B4A50"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 50,
    width: 4,
    height: 4,
    rx: 1,
    fill: "#4B4A50"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 31,
    width: 28,
    height: 2,
    rx: 1,
    fill: "#EF7C00"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 41,
    width: 28,
    height: 2,
    rx: 1,
    fill: "#EF7C00"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 51,
    width: 28,
    height: 2,
    rx: 1,
    fill: "#EF7C00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.3707 52.1446C55.1629 52.1506 55 52.3106 55 52.5026V52.5306C55 57.4759 55.8657 64.3851 60.1364 69.2285C62.7207 72.1601 65.2664 72.932 65.3757 72.964L65.4957 73L65.6114 72.964C65.7207 72.932 68.2814 72.1601 70.8657 69.2285C75.1343 64.3871 76 57.4759 76 52.5326V52.5046C76 52.3106 75.835 52.1526 75.6293 52.1466C75.5671 52.1446 69.3957 51.9366 65.77 49.091L65.7679 49.089C65.6179 48.969 65.3971 48.971 65.2471 49.091C61.6214 51.9346 55.435 52.1426 55.3707 52.1446ZM64.1645 63.4178L62.2037 61.5718C61.8557 61.2442 61.855 60.6914 62.2021 60.363C62.5221 60.0603 63.0225 60.0597 63.3431 60.3617L64.7414 61.6786L68.7058 57.9382C69.0261 57.636 69.5264 57.636 69.8467 57.9382C70.1944 58.2663 70.1944 58.8193 69.8467 59.1474L65.3211 63.4172C64.9965 63.7234 64.4894 63.7237 64.1645 63.4178Z",
    fill: "#E23E5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 15H0V0H26L21.0142 7.50103L26 15Z",
    fill: "#EF7C00"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 1.5,
    fill: "#CD6A00"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 7.5,
    r: 1.5,
    fill: "#CD6A00"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 7.5,
    r: 1.5,
    fill: "#CD6A00"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 15,
    fill: "#CD6A00"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgRemainder);
export default __webpack_public_path__ + "static/media/imgRemainder.b4dbc97fe8b481cbf0e0270e410a3641.svg";
export { ForwardRef as ReactComponent };